<template>
    <div class="pos-relative">
        <div v-if="isOpened === false" class="analyst-chart-group">

            <div class="analyst-chart__chart" :style="chartStyle">
                <pie-chart
                    :colors="[colors.vert, colors.jaune, colors.orange, colors.rouge]"
                    :data="[['Essentiel des dispositions', data.verts.total], ['Plusieurs des dispositions', data.jaunes.total], ['Certaines dispositions', data.oranges.total], ['Peu de dispositions', data.rouges.total]]"
                    :legend="false"
                    :width="chartSize"
                    :height="chartSize"
                ></pie-chart>
            </div>

            <div class="analyst-chart__content" :class="{'s-4-rpad':height>300}">

                <p><strong class="dark-medium">Des {{ total }} municipalités <span class="s-underline">ayant répondu au questionnaire</span>,</strong></p>

                <div class="media">
                    <div class="media-left"><spot :color="'vert'"></spot></div>
                    <div class="media-body"><strong class="dark-medium--cond">{{ calcPercent(data.verts) }} %</strong> {{ labelVert }}</div>
                    <div class="media-right s-1-lpad">
                        <template v-if="data.verts.total > 0">
                            <a class="-a-less-visible" @click="openDetails(data.verts, labelVert)" :title="makeTooltip(data.verts)"><span class="glyphicon glyphicon-fix-18 glyphicon-list-alt" aria-hidden="true"></span></a>
                        </template>
                    </div>
                </div>
                <div class="media">
                    <div class="media-left"><spot :color="'jaune'"></spot></div>
                    <div class="media-body"><strong class="dark-medium--cond">{{ calcPercent(data.jaunes) }} %</strong> {{ labelJaune }}</div>
                    <div class="media-right s-1-lpad">
                        <template v-if="data.jaunes.total > 0">
                            <a class="-a-less-visible" @click="openDetails(data.jaunes, labelJaune)" :title="makeTooltip(data.jaunes)"><span class="glyphicon glyphicon-fix-18 glyphicon-list-alt" aria-hidden="true"></span></a>
                        </template>
                    </div>
                </div>
                <div class="media">
                    <div class="media-left"><spot :color="'orange'"></spot></div>
                    <div class="media-body"><strong class="dark-medium--cond">{{ calcPercent(data.oranges) }} %</strong> {{ labelOrange }}</div>
                    <div class="media-right s-1-lpad">
                        <template v-if="data.oranges.total > 0">
                            <a class="-a-less-visible" @click="openDetails(data.oranges, labelOrange)" :title="makeTooltip(data.oranges)"><span class="glyphicon glyphicon-fix-18 glyphicon-list-alt" aria-hidden="true"></span></a>
                        </template>
                    </div>
                </div>
                <div class="media">
                    <div class="media-left"><spot :color="'rouge'"></spot></div>
                    <div class="media-body"><strong class="dark-medium--cond">{{ calcPercent(data.rouges) }} %</strong> {{ labelRouge }}</div>
                    <div class="media-right s-1-lpad">
                        <template v-if="data.rouges.total > 0">
                            <a class="-a-less-visible" @click="openDetails(data.rouges, labelRouge)" :title="makeTooltip(data.rouges)"><span class="glyphicon glyphicon-fix-18 glyphicon-list-alt" aria-hidden="true"></span></a>
                        </template>
                    </div>
                </div>

            </div>
        </div>

        <div v-else-if="isOpened.length === 2" class="analyst-data-group" :style="dataStyle">
            <article class="analyst-data-body">
                <div class="analyst-data-title">
                    <p><strong>Des {{ total }} municipalités ayant répondu au questionnaire,</strong>
                        <span v-html="detailTitle"></span>
                    </p>
                </div>
                <div class="analyst-data-scroll" :style="scrollStyle">
                    <div class="analyst-data-flex-2cols">
                        <municipalities-list :params="isOpened[0].params" />
                    </div>
                </div>
            </article>
            <div class="analyst-data-close">
                <a @click="closeDetails"><span class="glyphicon glyphicon-remove-circle" aria-hidden="true"></span></a>
            </div>
        </div>

    </div>
</template>

<script>
import { bilanChartMixin } from './mixins/bilan-chart-mixin';

export default {
    name: 'BilanChart',

    mixins: [
        bilanChartMixin
    ],

    props: {
        data: {
            type: Object,
            validator: function (value)
            {
                return (Object.keys(value).length === 4);
            }
        },
        labelVert: String,
        labelJaune: String,
        labelOrange: String,
        labelRouge: String,
    },

    data()
    {
        return {
            colors: {
                vert: '#70d2ab',
                jaune: '#f5df65',
                orange: '#f4a34d',
                rouge: '#ff6362',
            }
        };
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/bilan-chart.vue